import { useEffect } from 'react';
import config from 'utils/config';
import { isSandgresponse } from 'utils/helpers';
import { trackEvent, trackPageView } from 'utils/googleAnalytics';

const PAGE_PATH = '/repair-status';
const PAGE_TITLE = 'Vehicle Repair Status';

export const useRepairStatusAnalytics = ({ isAuthenticated, result }) => {
  const measurementId = config.repairStatusGaMeasurementId;
  const shouldTrack = measurementId && isSandgresponse();

  useEffect(() => {
    if (!shouldTrack) return;

    trackPageView(measurementId, PAGE_PATH, PAGE_TITLE);
  }, [shouldTrack, measurementId]);

  useEffect(() => {
    if (!shouldTrack || !isAuthenticated || !result) return;

    trackEvent(measurementId, 'repair_status_result_viewed');
  }, [shouldTrack, measurementId, isAuthenticated, result]);
};
